import * as React from 'react'
function SvgPhotoOff(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M23.894 27.012l-5.459 5.459h14.683c1.13 0 1.882-.753 1.882-1.883V17.412c0-.377-.188-.753-.376-1.13l-10.73 10.73zM34.435 8.565c-.753-.753-1.882-.753-2.635 0l-4.706 4.706-1.694-2.636c-.565-.376-1.13-.753-1.694-.753h-7.53c-.564 0-1.129.377-1.505.753l-3.2 4.894H6.765c-1.13 0-1.883.753-1.883 1.883v13.176c0 1.13.753 1.883 1.883 1.883h1.13l-2.448 2.447c-1.882 1.882.941 4.33 2.635 2.635L34.435 11.2c.753-.753.753-1.882 0-2.635zm-20.14 14.494c0-3.2 2.446-5.647 5.646-5.647.941 0 1.694.188 2.447.564l-7.53 7.53c-.376-.753-.564-1.506-.564-2.447z" />
			</g>
		</svg>
	)
}
export default SvgPhotoOff
